import endpoints, { axios } from "../config/api";

function addUserToProject(projectId: number, userId: string) {
  return axios.post(endpoints.project.addUser(projectId), [userId]);
}

export default addUserToProject;
